module.exports = __webpack_public_path__ + "static/media/bone-knife.8d6d549d.svg";